import PayrollRecord from "../../../classes/PayrollRecord";

export const GET_PAYROLL_RECORDS = ({ dispatch }, { where, limit } = {}) => {
  return dispatch("GET_COLLECTION", {
    converter: PayrollRecord,
    path: "payrollRecords",
    stateKey: "payrollRecords",
    where,
    limit,
  });
};

export const LISTEN_PAYROLL_RECORDS = (
  { dispatch },
  { where, next, error, unlisten } = {}
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: PayrollRecord,
    path: "payrollRecords",
    stateKey: "payrollRecords",
    where,
    next,
    error,
    unlisten,
  });
};
